import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import NewFloatingTaskWidget from './NewFloatingTaskWidget';

import timesheetActions from '../actions/timesheetActionCreators';


require.ensure([], () => {
    require('./DatePicker.less');
});

class LogOverviewHeader extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showFloatingTaskModal: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleButtonClick = () => {
        if (this.props.timesheet && (this.props.timesheet.status == "ENTRY" || this.props.timesheet.status === "FIXING")) {
            this.props.closeAllPopovers();
            this.props.dispatch(timesheetActions.submit(this.props.timesheet));
        } else if (this.props.timesheet && this.props.timesheet.status == "SUBMITTED") {
            this.props.closeAllPopovers();
            this.props.dispatch(timesheetActions.reopen(this.props.timesheet));
        }
    }

    handleCalendarClick = () => {
        this.setState({
            selectDate: true
        }, () => {
            if (this.refs.datePicker)
                this.refs.datePicker.handleFocus();
            else
                setTimeout(this.refs.datePicker.handleFocus, 100);
        });

        setTimeout(() => {
            moment.updateLocale('en', {
                week: { doy: 4, dow: 1 }
            });
        }, 150);
    }

    handleCloseFloatingTask = () => {
        this.setState({
            showFloatingTaskModal: false
        });
    }

    handleDateChange = (date) => {
        this.props.handleDateChange(date);
        setTimeout(() => {
            this.setState({
                selectDate: false
            });
        }, 350);
    }

    handleNewFloatingTask = () => {
        this.setState({
            showFloatingTaskModal: true
        });
    }

    // RENDER METHOD

    render = () => {
        let buttonText = "Submit";
        let buttonTitle = "Submit timesheet for this week. Submitted timesheets can not be edited.";


        let hoursSpent = this.props.hoursLogged;
        let minutesSpent = this.props.minutesLogged;
        let overtimeSpent = this.props.overtimeHoursLogged;
        let overtimeMinutesSpent = this.props.overtimeMinutesLogged;
        let regularHoursSpent = this.props.regularHoursLogged;

        let formattedStartDate = this.props.startDay ? this.props.startDay.format("D.M.") : "";
        let formattedEndDate = this.props.endDay ? this.props.endDay.format("D.M.") : "";

        let formatedWeek = this.props.startDay ? "(Week " + this.props.startDay.isoWeek() + ")" : "";

        let weekClass = (moment().isoWeek() === this.props.date.isoWeek()) && (moment().year() === this.props.date.year())  ? "label-day today" : "label-day";

        let timesheetActionElement = null;

        if (this.props.timesheet && this.props.timesheet.status === "APPROVED") {
            timesheetActionElement = <h4>Approved</h4>;
        }
        else if (this.props.timesheet && this.props.timesheet.status === "SUBMITTED") {
            timesheetActionElement = <h4>Submitted</h4>;
        } else if (this.props.canSubmit
                 && ((this.props.weeklyQuota === null || this.props.weeklyQuota === "null") && (hoursSpent + minutesSpent + overtimeSpent + overtimeMinutesSpent > 0)
                 || (this.props.weeklyQuota && regularHoursSpent === parseInt(this.props.weeklyQuota) && minutesSpent % 60 === 0))) {
            // we can submit a timesheet if and only canSubmit is true and either
            // we have no weekly quota but we have some log entries this week
            // or we do have a weekly quota and we have satisfied it exactly
            timesheetActionElement = <button title={buttonTitle} className="btn1 btn1-default" onClick={this.handleButtonClick} type="button">{buttonText} Week</button>;
        } else if(this.props.containsDurationlessTasks) {
          timesheetActionElement = <span className="logged-hours-show">Log entry without duration cannot be submitted.</span>;
        } else if (this.props.weeklyQuota) {
            let weeklyQuotaMinutes = 60 * parseInt(this.props.weeklyQuota);
            let totalRegularMinutes = 60 * regularHoursSpent + minutesSpent;

            let remaining = weeklyQuotaMinutes - totalRegularMinutes;
            let remainingHours = Math.abs((Math.trunc(remaining / 60)));
            let remainingMinutes = Math.abs(remaining % 60);

            if(this.props.writtenOnReturned)
                timesheetActionElement = <span className="logged-hours-show">Timesheet with returned floating task(s) cannot be submitted.</span>;
            else if(remaining === 0)
                timesheetActionElement = <span className="logged-hours-show">Log entry without duration cannot be submitted.</span>;
            else if (remaining > 0)
                timesheetActionElement = <span className="logged-hours-show">{remainingHours > 0 ? remainingHours + "h" : null} {remainingMinutes > 0 ? remainingMinutes + "min" : null} remaining</span>;
            else
                timesheetActionElement = <span className="logged-hours-show">{remainingHours > 0 ? remainingHours + "h" : null} {remainingMinutes > 0 ? remainingMinutes + "min" : null} excessive</span>;
        }

        let floatingTaskModal = <NewFloatingTaskWidget pmUsers={this.props.pmUsers} onRequestHide={this.handleCloseFloatingTask} />;

        return (
        <div className="text-center">
            <div className="week-header">
                {
                    this.state.showFloatingTaskModal ? floatingTaskModal : null
                }
                <div className="panel-log-date">
                    { this.props.loading ? null : <i onClick={this.props.decrementWeek} className="md-chevron-left md-lg"></i> }
                    <h4>
                        <span className={weekClass}>
                            <span>
                                {
                                this.state.selectDate ?
                                    <span className="no-show" style={{ display: "inline-block" }}><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;
                                        <DatePicker
                                            className="hideInput"
                                            ref="datePicker"
                                            dateFormat="YYYY-MM-DD"
                                            selected={this.props.startDay}
                                            onChange={this.handleDateChange}
                                            />
                                    </span>
                                    :
                                    <span><i onClick={this.handleCalendarClick} className="md-today"/>&nbsp;&nbsp;</span>
                                }
                                {formattedStartDate} - {formattedEndDate} {formatedWeek}
                            </span>
                        </span>
                    </h4>
                    { this.props.loading ? null : <i onClick={this.props.incrementWeek} className="md-chevron-right md-lg"></i> }
                </div>

                {
                    this.props.loading ? null :
                    <span className="logged-hours-show">Currently logged: {hoursSpent}h {minutesSpent > 0 ? minutesSpent + "min" : null} {overtimeSpent || overtimeMinutesSpent ? " + " + overtimeSpent + "h "  + (overtimeMinutesSpent > 0 ? overtimeMinutesSpent + " min" : "") + " overtime" : null}</span>
                }
                <div className="new-floating-button">
                    <button onClick={this.handleNewFloatingTask} title="Create new floating task" className="btn1 btn1-default btn1-centered" type="button">New Floating Task</button>
                </div>
                <div className="submit-week">
                    { timesheetActionElement }
                </div>
            </div>
        </div>
        );
    }
}

LogOverviewHeader.propTypes = {
    canSubmit: PropTypes.bool,
    closeAllPopovers: PropTypes.func,
    date: PropTypes.object,
    decrementWeek: PropTypes.func,
    dispatch: PropTypes.func,
    endDay: PropTypes.object,
    handleDateChange: PropTypes.func,
    hoursLogged: PropTypes.number,
    incrementWeek: PropTypes.func,
    loading: PropTypes.bool,
    minutesLogged: PropTypes.number,
    overtimeHoursLogged: PropTypes.number,
    overtimeMinutesLogged: PropTypes.number,
    pmUsers: PropTypes.array,
    regularHoursLogged: PropTypes.number,
    startDay: PropTypes.object,
    timesheet: PropTypes.object,
    weeklyQuota: PropTypes.number,
    writtenOnReturned: PropTypes.bool,
    containsDurationlessTasks: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        error: state.users.error,
        timesheet: state.timesheets.currentTimesheet
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogOverviewHeader);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogOverviewHeader.js
 **/